module.exports = __webpack_public_path__ + "img/snpark_detail.02ef1386.jpg";